import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  gapRow?: string;
  gapColumn?: string;
  column?: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'form-unit',
  props: {
    modifires: { type: [String, Array, Boolean] },
    gapRow: { default: "0" },
    gapColumn: { default: "0" },
    column: { default: () => ["auto"] }
  },
  setup(__props: any) {

const props = __props;

_useCssVars(_ctx => ({
  "5d001206": (_ctx.gapRow),
  "56f0aa38": (_unref(column)),
  "71957baa": (_ctx.gapColumn)
}))



const column = props.column?.join(" ");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('form-unit', _ctx.modifires))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})